import { timeZoneRangeLoadState } from "../store";

export default function getTimeZoneRangeLoadState(): string {
    return timeZoneRangeLoadState;
}
